<template>

    <button

        class="btn btn-light border m-2 btn-verde "
        style="width: 120px; height: 100px;"
    >
        <img
        :src=src
        alt="option"
        class="img-fluid"
        style="max-height: 50px;"
        />
        {{ label }}
    </button>

  </template>
  
  <script>
  export default {
    props: {
      label: String,
      src: String,
    },
  };
  </script>
  
  <style scoped>
  /* Estilos adicionais para os botões */
  button img {
    display: block;
    margin: 0 auto;
  }

  .btn:hover {
    background-color: #d3ffe6;
  }

  .btn-verde {
    background-color: #d3ffe6;
  }
  </style>